import { httpClient } from '../utils/dataProvider';

const API = 'https://skilzapp.net/api';
const PAGE_LIMIT = 100;

const responseJson = response => {
  if (typeof response !== 'object' || response === null) return response;
  return response.json || response.body || response;
};

export const fetchAllReportLogs = async () => {
  const logs = [];
  const visitedPages = new Set();
  let page = 1;

  while (page && !visitedPages.has(page)) {
    visitedPages.add(page);
    const response = await httpClient(`${API}/logs?action=REPORT&page=${page}&limit=${PAGE_LIMIT}`, { method: 'GET' });
    const json = responseJson(response);
    const docs = Array.isArray(json) ? json : (json && Array.isArray(json.docs) ? json.docs : []);
    logs.push(...docs);

    if (!json || Array.isArray(json) || !json.hasNextPage) break;
    page = json.nextPage;
  }

  return logs;
};
